import { createAsyncThunk } from '@reduxjs/toolkit';
import { controller, projectController } from '../../api/controller';

export const checkUser = createAsyncThunk('auth/checkUser', async (payload, { rejectWithValue }) => {
  try {
    console.log('Calling controller.checkUser with:', payload);
    const response = await controller.checkUser(payload);
    console.log('checkUser response:', response);
    if (!response || !response.user || !response.access_token) {
      console.error('Invalid response from checkUser:', response);
      throw new Error('Invalid response from checkUser');
    }
    return response;
  } catch (error) {
    console.error('checkUser error:', error.message, error.response?.data || error);
    return rejectWithValue({
      message: error.response?.data?.message || error.message || 'Login failed',
      code: error.response?.data?.code || null,
      email: error.response?.data?.email || null,
    });
  }
});

export const validateStoredToken = createAsyncThunk('auth/validateStoredToken', async (_, { rejectWithValue }) => {
  try {
    console.log('Calling controller.validateToken');
    const response = await controller.validateToken();
    console.log('validateStoredToken response:', response);
    // Каталог: { user, access_token? }; проектный /auth/profile — плоский объект пользователя
    const user =
      response?.user != null
        ? response.user
        : response && response.id != null && response.username != null
          ? response
          : null;
    if (!user) {
      console.error('Invalid response from validateToken:', response);
      throw new Error('Invalid response from validateToken');
    }
    return { user };
  } catch (error) {
    console.error('validateStoredToken error:', error.message, error.response?.data || error);
    return rejectWithValue(
      error.response?.data?.message || error.message || 'Token validation failed',
    );
  }
});

export const createUser = createAsyncThunk('auth/createUser', async (payload, { rejectWithValue }) => {
  try {
    console.log('Calling controller.createUser with:', payload);
    const response = await controller.createUser(payload);
    console.log('createUser response:', response);
    return response.data;
  } catch (error) {
    console.error('createUser error:', error);
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const getUsers = createAsyncThunk('auth/getUsers', async (_, { rejectWithValue }) => {
  try {
    console.log('Calling projectController.getUsers');
    const response = await projectController.get('/users');
    console.log('getUsers response:', response);
    return response.data;
  } catch (error) {
    console.error('getUsers error:', error);
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});
